import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../commonComponents/translate';
import Anchor from '../../commonComponents/Anchor';

function Certification({ t }) {
  return (
    <div className="landing-certification-container">
      <h3 className="landing-certification-title">
        {t('landing_certificationTitle')}
      </h3>
      <Anchor
        href="/academy"
        className="landing-certification-browse btn m-btn--pill btn-dynamic"
      >
        {t('landing_browseAll')}
      </Anchor>
    </div>
  );
}

Certification.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(Certification);
